module.exports = __webpack_public_path__ + "img/infibo-how-to-subscribe-ru-2.40f325fa.png";